/* ==========================================================================
   Gild & Ink — shared shortlist (hearted-pieces) behaviour for the Collection
   (piece-type) and Ranges pages.

   This used to also run a "suite tray" (add several pieces, then a bottom
   bar to personalise them together) — removed per Michael's Round 5 call:
   too much of an in-between step. The route now is direct: click a piece's
   image or "View" to land on its own product page, which already has its
   own "Complete your suite" step for adding matching pieces
   (?view=customise — see sections/gi-customise-page.liquid). See
   gild-ink-collections-redesign-theme memory for the full history.

   The shortlist (heart icon) is unrelated and unaffected — it's read/written
   here so hearts on this page's cards stay in sync with the header's
   shortlist panel, both backed by the single window.GiShortlist store
   defined in assets/gi-shortlist.js (loaded globally from the header).

   Data contract (rendered by snippets/gi-piece-card.liquid):
     data-gi-shortlist data-id="<Range>|<Piece>" data-range="<Range>"
     data-piece="<Piece>" data-label="<Range Piece>"
     data-variant-id="<numeric variant gid id>" data-handle="<product handle>"

   localStorage key: gi-shortlist. Array of
   { id, range, piece, label, variantId, handle }.
   ========================================================================== */
(function () {
  'use strict';

  var SHORTLIST_KEY = 'gi-shortlist';

  function readStore(key) {
    try {
      var raw = window.localStorage.getItem(key);
      var val = raw ? JSON.parse(raw) : [];
      return Array.isArray(val) ? val : [];
    } catch (e) {
      return [];
    }
  }
  function writeStore(key, arr) {
    try { window.localStorage.setItem(key, JSON.stringify(arr)); } catch (e) { /* ignore */ }
  }

  function makeStore(key) {
    var listeners = [];
    var items = readStore(key);

    function persist() { writeStore(key, items); listeners.forEach(function (fn) { fn(items); }); }

    return {
      all: function () { return items.slice(); },
      has: function (id) { return items.some(function (i) { return i.id === id; }); },
      get: function (id) { return items.find(function (i) { return i.id === id; }); },
      add: function (item) {
        if (this.has(item.id)) return;
        items.push(item);
        persist();
      },
      remove: function (id) {
        items = items.filter(function (i) { return i.id !== id; });
        persist();
      },
      toggle: function (item) {
        if (this.has(item.id)) { this.remove(item.id); return false; }
        this.add(item);
        return true;
      },
      clear: function () { items = []; persist(); },
      onChange: function (fn) { listeners.push(fn); }
    };
  }

  // assets/gi-shortlist.js (loaded globally from the header) already creates
  // window.GiShortlist on every page, including this one — reuse it so the
  // header's count/panel and this page's hearts share one store and one set
  // of change listeners. Only fall back to a local store if that script
  // somehow didn't load.
  var GiShortlist = window.GiShortlist || makeStore(SHORTLIST_KEY);
  window.GiShortlist = GiShortlist;

  function datasetItem(el) {
    return {
      id: el.getAttribute('data-id'),
      range: el.getAttribute('data-range'),
      piece: el.getAttribute('data-piece'),
      label: el.getAttribute('data-label'),
      variantId: el.getAttribute('data-variant-id'),
      handle: el.getAttribute('data-handle') || ''
    };
  }

  /* ---------- shortlist button wiring (delegated, works for JS-built chips too) ---------- */
  document.addEventListener('click', function (e) {
    var heartBtn = e.target.closest('[data-gi-shortlist]');
    if (heartBtn) {
      var hitem = datasetItem(heartBtn);
      if (!hitem.id) return;
      GiShortlist.toggle(hitem);
      syncHeartButtons(hitem.id);
      return;
    }
  });

  function syncHeartButtons(id) {
    var on = GiShortlist.has(id);
    document.querySelectorAll('[data-gi-shortlist][data-id="' + cssEscape(id) + '"]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? '♥' : '♡';
    });
  }
  function cssEscape(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  /* ---------- hydrate on load: reflect stored state onto whatever cards exist on THIS page ---------- */
  function hydrate() {
    document.querySelectorAll('[data-gi-shortlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-id');
      if (!id) return;
      if (GiShortlist.has(id)) { btn.setAttribute('aria-pressed', 'true'); btn.textContent = '♥'; }
      else { btn.setAttribute('aria-pressed', 'false'); btn.textContent = '♡'; }
    });
  }

  document.addEventListener('DOMContentLoaded', hydrate);
  if (document.readyState !== 'loading') { hydrate(); }
})();
